import AdminPanel from "../views/AdminPanel/index.vue";
// import UserAccounts from "../views/orginfo/UserAccounts.vue";
import OperatorPanel from "../views/OperatorPanel.vue";
import MailToWinners from "../views/MailToWinners/index.vue";
import AdminPanelFinexpert from "../views/AdminPanelFinexpert/index.vue";

const menu = [
  {
    title: "Панель администратора",
    icon: "fa fa-building",
    url: "/adminpanel",
    meta: { calcAdmin: true, bankir: false },
    id: 9,
  },
  {
    title: "Панель FinExpert",
    icon: "fa fa-building",
    url: "/adminpanelfinexpert",
    meta: { calcAdmin: true, bankir: false },
    id: 9.5,
  },
  // {
  //   title: "Мои сотрудники",
  //   icon: "fa fa-user",
  //   url: "/userAccounts",
  //   meta: { calcAdmin: true, bankir: false },
  // },
  {
    title: "Панель оператора",
    icon: "fa fa-user-circle",
    url: "/operatorpanel",
    meta: { calcAdmin: true, bankir: false },
    id: 10,
  },
  {
    title: "Рассылка победителям",
    icon: "fa fa-envelope",
    url: "/MailToWinners",
    meta: { calcAdmin: true, bankir: false },
    id: 11,
  },
];

const routes = [
  {
    path: "/operatorpanel",
    name: "operatorpanel",
    component: OperatorPanel,
    meta: {
      forAuth: true,
      calcAdmin: true,
      bankir: false,
    },
  },
  {
    path: "/adminpanel",
    name: "adminpanel",
    component: AdminPanel,
    meta: {
      forAuth: true,
      calcAdmin: true,
      bankir: false,
    },
  },
  {
    path: "/adminpanelfinexpert",
    name: "adminpanelfinexpert",
    component: AdminPanelFinexpert,
    meta: {
      forAuth: true,
      calcAdmin: true,
      bankir: false,
    },
  },
  // {
  //   path: "/userAccounts",
  //   name: "userAccounts",
  //   component: UserAccounts,
  //   meta: {
  //     forAuth: true,
  //     calcAdmin: true, bankir: false,
  //   },
  // },
  {
    path: "/MailToWinners",
    name: "MailToWinners",
    component: MailToWinners,
    meta: {
      forAuth: true,
      calcAdmin: true,
      bankir: false,
    },
  },
];

export default { menu, routes };
